import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawUserSignatureModel extends BaseModel {
  rawFormFields(item = undefined) {
    return [
      {
        name: "firstName",
        displayName: this.fieldDisplayName("firstName"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
      },
      {
        name: "lastName",
        displayName: this.fieldDisplayName("lastName"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
      },
      {
        name: "place",
        displayName: this.fieldDisplayName("place"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
      },
      {
        name: "date",
        displayName: this.fieldDisplayName("date"),
        type: "dateTime",
        format: "DD.MM.YYYY",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6,
        readOnly: true
      },
    ]
  }

  i18nScope() {
    return "model.users.signature";
  }
}

const UserSignatureModel = new RawUserSignatureModel();

export { RawUserSignatureModel, UserSignatureModel }